import { render, staticRenderFns } from "./FeedbackCreateDialog.vue?vue&type=template&id=051bd5b1&scoped=true"
import script from "./FeedbackCreateDialog.vue?vue&type=script&lang=ts"
export * from "./FeedbackCreateDialog.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackCreateDialog.vue?vue&type=style&index=0&id=051bd5b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051bd5b1",
  null
  
)

export default component.exports